// Layouts
import LayoutLanding from '@layouts/LayoutLanding';
import LayoutLegal from '@layouts/LayoutLegal';

// Pages
import PageContact from '@pages/contact';
import PageFeature from '@pages/feature';
import PageHome from '@pages/home';
import PagePricing from '@pages/pricing';
import PagePrivacy from '@pages/legal/PagePrivacy';
import PageRegulations from '@pages/legal/PageRegulations';
import PageSecurity from '@pages/legal/PageSecurity';
import PageTerms from '@pages/legal/PageTerms';

export const routes = [
    {
        path: '/',
        component: LayoutLanding,
        children: [
            {
                path: '',
                name: 'home',
                component: PageHome,
            },
            {
                path: 'pricing',
                name: 'pricing',
                component: PagePricing,
                meta: {
                    title: 'Pricing',
                },
            },
            {
                path: 'features/customer-engagement',
                name: 'feature-engagement',
                component: PageFeature,
                meta: {
                    title: 'Customer Engagement',
                },
            },
            {
                path: 'features/customer-management',
                name: 'feature-management',
                component: PageFeature,
                meta: {
                    title: 'Customer Management',
                },
            },
            {
                path: 'features/customer-segmenting',
                name: 'feature-segmenting',
                component: PageFeature,
                meta: {
                    title: 'Customer Segmenting',
                },
            },
            {
                path: 'features/email-builder',
                name: 'feature-email',
                component: PageFeature,
                meta: {
                    title: 'Send Personalized Emails to Your Customers',
                },
            },
            {
                path: 'contact',
                name: 'contact',
                component: PageContact,
                meta: {
                    title: 'Contact',
                },
            },
        ]
    },
    {
        path: '/',
        component: LayoutLegal,
        children: [
            {
                path: 'privacy',
                name: 'privacy',
                component: PagePrivacy,
                meta: {
                    title: 'Privacy Policy',
                },
            },
            {
                path: 'terms',
                name: 'terms',
                component: PageTerms,
                meta: {
                    title: 'Terms of Service',
                },
            },
            {
                path: 'security',
                name: 'security',
                component: PageSecurity,
                meta: {
                    title: 'Security',
                },
            },
            {
                path: 'privacy-regulations',
                name: 'privacy-regulations',
                component: PageRegulations,
                meta: {
                    title: 'Privacy Regulations Compliance (GDPR)',
                },
            },
        ]
    },
    {
        path: '/appsumo/:code?',
        beforeEnter(to) { location.href = `${process.env.VUE_APP_APP_URL}/appsumo/${to.params.code || ''}` },
    },
    {
        path: '/ltd/:code?',
        beforeEnter(to) { location.href = `${process.env.VUE_APP_APP_URL}/ltd/${to.params.code || ''}` },
    },
    {
        path: '/signup',
        beforeEnter() { location.href = `${process.env.VUE_APP_APP_URL}/signup` },
    },
    {
        path: '/login',
        beforeEnter() { location.href = `${process.env.VUE_APP_APP_URL}/login` },
    },
    {
        path: '*',
        redirect: '/',
    },
];